module.exports = __webpack_public_path__ + "img/report_8-1.3ddce721.jpg";